"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var inputs_1 = require("../../../components/formsets/inputs");
var lines_2 = tslib_1.__importDefault(require("../po/lines"));
var AccountsPayableLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsPayableLineResource, _super);
    function AccountsPayableLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccountsPayableLineResource, "related", {
        get: function () {
            return Object.assign({}, lines_1.BaseLineResource.related, {
                relieves: lines_2.default,
            });
        },
        enumerable: true,
        configurable: true
    });
    AccountsPayableLineResource.endpoint = '/lines/ap';
    AccountsPayableLineResource.MODEL_NAME = 'accountspayableline';
    AccountsPayableLineResource.defaultFormset = {
        relieves: new inputs_1.inputs.PrimaryKeyInput('PO', 'description'),
        series: new inputs_1.inputs.PrimaryKeyInput('SER', 'code'),
        location: new inputs_1.inputs.PrimaryKeyInput('LOC', 'code'),
        set: new inputs_1.inputs.PrimaryKeyInput('SET', 'code'),
        account: new inputs_1.inputs.PrimaryKeyInput('Account', 'code'),
        account_name: new inputs_1.inputs.ReadOnlyInput('Account Name', { props: { tabindex: '-1' } }),
        description: new inputs_1.inputs.DefaultInput('Description'),
        amount_decimal: new inputs_1.inputs.CurrencyInput('Amount'),
    };
    return AccountsPayableLineResource;
}(lines_1.BaseLineResource));
exports.default = AccountsPayableLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/ap/lines.js
// module id = oK3s
// module chunks = 0